import React from "react";
import PropTypes from "prop-types";

import { useStore } from "base/basestore";

import styles from "./toolbarandgrid.css";

ToolbarAndGrid.propTypes = {
  children: PropTypes.node
};

export function ToolbarAndGrid({ children }) {
  const { useStateStore: useGridStore } = useStore();

  const showFilter = useGridStore((state) => state.showFilter);
  const slots = React.Children.map(children, (child) => child);
  let toolbar;
  let grid;
  let filter;
  slots.forEach((child) => {
    if (child.type === ToolbarAndGrid.Toolbar) {
      toolbar = child;
    } else if (child.type === ToolbarAndGrid.Grid) {
      grid = child;
    } else if (child.type === ToolbarAndGrid.Filter) {
      filter = child;
    }
  });

  return (
    <div className={`${styles.content}`}>
      {toolbar}
      <div className={styles.gridAndFilter}>
        {grid}
        {showFilter && (
          <div className={`shadow-16dp ${styles.filterContainer}`}>
            {filter}
          </div>
        )}
      </div>
    </div>
  );
}
function Toolbar(props) {
  return <React.Fragment>{props.children}</React.Fragment>;
}
Toolbar.propTypes = {
  children: PropTypes.node
};

ToolbarAndGrid.Toolbar = Toolbar;
ToolbarAndGrid.Toolbar.displayName = "ToolbarAndGrid.Toolbar";

function Grid(props) {
  return <React.Fragment>{props.children}</React.Fragment>;
}
Grid.propTypes = {
  children: PropTypes.node
};

ToolbarAndGrid.Grid = Grid;
ToolbarAndGrid.Grid.displayName = "ToolbarAndGrid.Grid";
function Filter(props) {
  return <React.Fragment>{props.children}</React.Fragment>;
}
Filter.propTypes = {
  children: PropTypes.node
};

ToolbarAndGrid.Filter = Filter;
ToolbarAndGrid.Filter.displayName = "ToolbarAndGrid.Filter";
